import { removeTrapFocus, trapFocus, lockScroll, closeDrawer, setDrawerOpenAccessibility, setDrawerClosedAccessibility } from '@theme/theme-global'
if (!customElements.get('pickup-availability')) {
  customElements.define(
    'pickup-availability',
    class PickupAvailability extends HTMLElement {
      constructor() {
        super();

        if (!this.hasAttribute('available')) {
          this.setProductBlockHidden(true);
          return;
        }

        this.errorHtml = this.querySelector('template').content.firstElementChild.cloneNode(true);
        this.onClickRefreshList = this.onClickRefreshList.bind(this);
        this.fetchAvailability(this.dataset.variantId);
      }

      get productBlock() {
        return this.closest('.product-block');
      }

      setProductBlockHidden(hidden) {
        if (!this.productBlock) return;

        if (hidden) {
          this.productBlock.setAttribute('hidden', '');
        } else {
          this.productBlock.removeAttribute('hidden');
        }
      }

      fetchAvailability(variantId) {
        if (!variantId) return;

        let rootUrl = this.dataset.rootUrl;
        if (!rootUrl.endsWith('/')) {
          rootUrl = rootUrl + '/';
        }
        const variantSectionUrl = `${rootUrl}variants/${variantId}/?section_id=pickup-availability`;

        fetch(variantSectionUrl)
          .then((response) => response.text())
          .then((text) => {
            const sectionInnerHTML = new DOMParser()
              .parseFromString(text, 'text/html')
              .querySelector('.shopify-section');
            this.renderPreview(sectionInnerHTML);
          })
          .catch((e) => {
            const button = this.querySelector('button');
            if (button) button.removeEventListener('click', this.onClickRefreshList);
            this.renderError();
          });
      }

      onClickRefreshList() {
        this.fetchAvailability(this.dataset.variantId);
      }

      update(variant) {
        if (variant?.available) {
          this.dataset.variantId = variant.id;
          this.setAttribute('available', '');
          this.fetchAvailability(variant.id);
        } else {
          this.removeAttribute('available');
          this.innerHTML = '';
          this.setProductBlockHidden(true);
        }
      }

      renderError() {
        this.innerHTML = '';
        this.appendChild(this.errorHtml);

        this.querySelector('button').addEventListener('click', this.onClickRefreshList);
      }

      renderPreview(sectionInnerHTML) {
        // const drawer = document.querySelector('pickup-availability-drawer');
        const drawer = document.querySelector(`#pickup-availability-drawer-pickup-availability-${this.dataset.variantId}`);
        // console.log(drawer);
        if (drawer) drawer.remove();
        if (!sectionInnerHTML.querySelector('pickup-availability-preview')) {
          this.innerHTML = '';
          this.removeAttribute('available');
          this.setProductBlockHidden(true);
          return;
        }

        this.innerHTML = sectionInnerHTML.querySelector('pickup-availability-preview').outerHTML;
        this.setAttribute('available', '');
        this.setProductBlockHidden(false);
        document.body.appendChild(sectionInnerHTML.querySelector(`#pickup-availability-drawer-pickup-availability-${this.dataset.variantId}`));
        document.querySelector(`#pickup-availability-drawer-pickup-availability-${this.dataset.variantId}`).classList.add(this.dataset.productPageColorScheme);

        const button = this.querySelector('button');
        if (button)
          button.addEventListener('click', (evt) => {
            document.querySelector(`#pickup-availability-drawer-pickup-availability-${this.dataset.variantId}`).show(evt.target);
          });
      }
    }
  );
}

if (!customElements.get('pickup-availability-drawer')) {
  customElements.define(
    'pickup-availability-drawer',
    class PickupAvailabilityDrawer extends HTMLElement {
      constructor() {
        super();

        const closeTriggers = this.querySelectorAll('[is="close-drawer"]');
        closeTriggers.forEach((trigger) => {
          trigger.addEventListener('click', (e) => {
            closeDrawer(e.target);
            removeTrapFocus(this.focusElement || this);
          });
        });

        this.addEventListener('keyup', (event) => {
          if (event.code.toUpperCase() === 'ESCAPE') {
            closeDrawer(event.target);
            removeTrapFocus(this.focusElement || this);
          }
        });
      }

      handleBodyClick(evt) {
        const target = evt.target;
        if (
          target != this &&
          !target.closest('pickup-availability-drawer') &&
          target.id != 'ShowPickupAvailabilityDrawer'
        ) {
          this.hide();
        }
      }

      hide() {
        this.removeAttribute('open');
        this.removeAttribute('active');
        setDrawerClosedAccessibility(this);
        removeTrapFocus(this.focusElement || this);
      }

      show(focusElement) {
        this.focusElement = focusElement;
        setDrawerOpenAccessibility(this);
        this.setAttribute('open', '');
        this.setAttribute('active', '');
        trapFocus(this, this.querySelector('.drawer-close-btn') || this, { push: true });
        lockScroll?.();
      }
    }
  );
}
